import { FC, useEffect, useState } from "react";
import { DefaultGrid } from "../../../../components/grids/default/defaultGrid";
import { PluginWrapper } from "../../../../components/plugins";
import { IInvoiceOutViewDTO } from "../../../../libs/coreapi-dto/documents/invoiceOut";
import { InvoiceOutDataProvider } from "../../../../Services/DataProviders/InvoiceOutDataProvider";
import useGridFilter, { MovementDateGridFilter, DefaultDateGridFilter } from "../../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../../system/providers/appContextProvider";
import styles from "../styles/index.module.scss";
import { DocumentGridStateType } from "../../../../@types/documents";
import { DocumentStatusType, LoadingStatus } from "../../../../@types/enumsGlobal";
import { Spinner } from "../../../../components/spiner/Spinner";

export const InvoiceOutGrid: FC<IDocumentGridProps<IGridProps>> = (props) => {

    //context
    const appContext = useAppContext();

    //dataproviders
    const invoiceOutDP = new InvoiceOutDataProvider(appContext.coreApiService);

    const [data, setData] = useState<IInvoiceOutViewDTO[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>([]);
    const [multipleSelect, setMultipleSelect] = useState<boolean>(false);
    const [gridFilter, dispatchGridFilter] = useGridFilter(props.gridProps.baseGridFilter ?? MovementDateGridFilter(props.dateDocument, props.idStoreGlobal));
    const [viewState, setViewState] = useState<DocumentGridStateType>("view");
    const [selectedDocumentState, setSelectedDocumentState] = useState<DocumentStatusType | undefined>();

    //TODO использовать здесь перечисление статуса загрузки ?
    const [, setLoadingStatus] = useState<LoadingStatus>();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    //TODO selectedItemView не используется ?
    const [selectedItemView, setSelectedItemViews] = useState<IInvoiceOutViewDTO>();

    //функция-обработчик обновления состояний по фильтру для вью
    const refreshWithFilter = (filter: IGridFilter) => {
        setIsSubmitting(true);
        invoiceOutDP.getView(filter, async (data, totalCount) => {
            setData(data);
            setTotalCount(totalCount);
            setLoadingStatus(LoadingStatus.Completed);
            setIsSubmitting(false);

            if (locker)
                setTimeout(() => locker = false, 500);
        });
    };

    //переменная "замок"
    let locker = false;

    //функция-обработчик стороннего эффекта: обновления по базовому фильтру верхнего уровня вью,
    //при изменении фильтра верхнего уровня
    useEffect(() => {
        locker = true;
        if (!isSubmitting && props.gridProps.baseGridFilter)
            refreshWithFilter(props.gridProps.baseGridFilter);
        else locker = false
    }, [props.gridProps.baseGridFilter]);

    //функция-обработчик стороннего эффекта: обновления по базовому фильтру верхнего уровня вью,
    //при изменении фильтра верхнего уровня или при изменении состояния грида
    useEffect(() => {
        if (!locker)
            refreshWithFilter(gridFilter);
    }, [viewState, gridFilter]);

    //функция-обработчик стороннего эффекта: обновления по базовому фильтру верхнего уровня вью,
    //при изменении состояния грида, когда состояние грида равно "refresh"
    useEffect(() => {
        if (viewState === "refresh") {
            setIsSubmitting(true);
            invoiceOutDP.getView(gridFilter, async (data, totalCount) => {
                setData(data);
                setTotalCount(totalCount);
                setLoadingStatus(LoadingStatus.Completed);
                setViewState("view");
                setIsSubmitting(false);
            });
        }
    }, [viewState]);

    //функция-обработчик стороннего эффекта: установка выбранного документа только для одного выбранного документа
    //при изменении режима выбора однострочный-многострочный и при изменении выбранного документа
    useEffect(() => {
        if (!multipleSelect) {
            setSelectedItems([]);
        } else {
            setSelectedItem(undefined);
        }

        if (selectedItem) {
            const documentState = selectedItem.cells.find((c) => c.propertyName === "documentState")?.value as DocumentStatusType;
            setSelectedDocumentState(documentState ?? undefined);
            setSelectedItemViews(data.find((x) => x.idGlobal === selectedItem.idGlobal));
        } else {
            setSelectedItemViews(undefined);
        }
    }, [multipleSelect, selectedItem]);

    return (
        <PluginWrapper>           
            <div className={styles.gridWrapper}>
                <div className={styles.masterGrid}>
                    {isSubmitting ? (
                        <Spinner />
                    ) : (
                        <DefaultGrid
                            selectedItems={selectedItems}
                            singleDirectory
                            separator
                            gridId={props.gridProps.gridId}
                            data={data}
                            filter={gridFilter}
                            dataProvider={invoiceOutDP}
                            totalCount={totalCount}
                            plugin={props.gridProps.plugin}
                            selectedItem={selectedItem}
                            multipleSelect={multipleSelect}
                            onMultipleSelect={(rows) => setSelectedItems(rows)}
                            onSelect={(row) => {
                                setSelectedItem(row);
                                props.gridProps.onSelect?.(row);
                            }}
                            onSort={(i) => {
                                dispatchGridFilter({ type: "sort", payload: i.propertyName });
                            }}
                            onFilterDelete={(i) => {
                                dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName });
                            }}
                            onPageNumberChange={(n) => {
                                dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } });
                            }}
                            onNumberPerPageChange={(n) => {
                                dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } });
                            }}
                        />
                    )}
                </div>              
            </div>
        </PluginWrapper>
    );
};
